import { Routes } from '@angular/router';
import { authenticatedGuard } from './core/guards/authenticated.guard';
import { loginGuard } from './core/guards/login.guard';
import { ErrorsComponent } from './features/errors/errors.component';
import { LayoutDefaultComponent } from './shared/layouts/layout-default/layout-default.component';
import { HomeComponent } from './features/home/home.component';
import { branchGuard } from './core/guards/branch.guard';
import { cashGuard } from './core/guards/cash.guard';
import { roleGuard } from './core/guards/role.guard';
import { TutorialsComponent } from './features/tutorials/tutorials.component';
import { resetPassGuard } from './core/guards/reset-password.guard';
import { adminAccess } from './core/lists/AdminAccessRoles';

// Definições de guards para evitar repetição
const baseGuards = [authenticatedGuard, resetPassGuard, branchGuard, cashGuard, roleGuard];

export const routes: Routes = [
  // Home
  { path: '', component: HomeComponent },

  // Autenticação
  {
    path: 'auth',
    canActivate: [loginGuard],
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'login',
    canActivate: [loginGuard],
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },

  // Funcionalidades principais
  {
    path: 'reservas',
    data: { roles: ['RESERVA'] },
    canActivate: baseGuards,
    loadChildren: () =>
      import('./features/schedules/schedules.module').then(
        (m) => m.SchedulesModule
      ),
  },
  // {
  //   path: 'patio',
  //   canActivate: baseGuards,
  //   loadChildren: () =>
  //     import('./features/parking/parking.module').then((m) => m.ParkingModule),
  // },
  {
    path: 'entrada',
    data: { roles: ['ENTRADA'] },
    canActivate: baseGuards,
    loadChildren: () =>
      import('./features/attendance/attendance.module').then(
        (m) => m.AttendanceModule
      ),
  },
  {
    path: 'checklists',
    data: { roles: ['CHECKLIST'] },
    canActivate: baseGuards,
    loadChildren: () =>
      import('./domains/Checklist/checklist.module').then(
        (m) => m.ChecklistModule
      ),
  },
  {
    path: 'caixa',
    data: { roles: ['CAIXA'] },
    canActivate: baseGuards,
    loadChildren: () =>
      import('./features/cash/cash.module').then((m) => m.CashModule),
  },
  {
    path: 'conferencias',
    data: { roles: ['CONFERENCIA'] },
    canActivate: baseGuards,
    loadChildren: () =>
      import('./features/conferences/conferences.module').then(
        (m) => m.ConferencesModule
      ),
  },

  // Administração
  {
    path: 'administracao',
    canActivate: baseGuards,
    data: { roles: adminAccess },
    loadChildren: () =>
      import('./features/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'relatorios',
    canActivate: baseGuards,
    data: { roles: adminAccess },
    loadChildren: () =>
      import('./features/reports/reports.module').then((m) => m.ReportsModule),
  },

  // Layout com páginas específicas
  {
    path: '',
    component: LayoutDefaultComponent,
    children: [
      {
        path: 'tutoriais',
        canActivate: baseGuards,
        component: TutorialsComponent,
      },
      {
        path: 'erro/:code',
        canActivate: [authenticatedGuard, branchGuard, cashGuard],
        component: ErrorsComponent,
      },
    ],
  },

  // Versão 2 - Domínios
  {
    path: 'v2/administracao/cartoes',
    canActivate: baseGuards,
    data: { roles: [ 'ADMIN_CARTAO'] },
    loadChildren: () =>
      import('./domains/Card/card.routing').then((m) => m.cardRoutes),
  },
  {
    path: 'v2/administracao/clientes',
    canActivate: baseGuards,
    data: { roles: ['ADMIN_CLIENTE'] },
    loadChildren: () =>
      import('./domains/Customer/customer.routing').then(
        (m) => m.customerRoutes
      ),
  },
  {
    path: 'v2/administracao/vagas',
    canActivate: baseGuards,
    data: { roles: ['ADMIN_VAGA'] },
    loadChildren: () =>
      import('./domains/Spot/spot.routing').then((m) => m.spotRoutes),
  },
  {
    path: 'v2/administracao/entradas',
    canActivate: baseGuards,
    data: { roles: ['ADMIN_ENTRADA'] },
    loadChildren: () =>
      import('./domains/Attendance/attendance.routing').then(
        (m) => m.attendanceRoutes
      ),
  },
  {
    path: 'v2/administracao/despesas-receitas',
    canActivate: baseGuards,
    data: { roles: ['ADMIN_DESPESA_RECEITA'] },
    loadChildren: () =>
      import('./domains/Invoice/invoice.routing').then((m) => m.invoiceRoutes),
  },
  {
    path: 'painel-de-controle',
    canActivate: baseGuards,
    data: { roles: ['PAINEL_CONTROLE'] },
    loadChildren: () =>
      import('./domains/Report/report.routing').then((m) => m.reportRoutes),
  },
  {
    path: 'v2/caixa',
    canActivate: baseGuards,
    data: { roles: ['CAIXA'] },
    loadChildren: () =>
      import('./domains/Cash/cash.routing').then((m) => m.cashRoutes),
  },
  {
    path: 'v2/patio',
    canActivate: baseGuards,
    data: { roles: ['PATIO','PENDENTE'] },
    loadChildren: () =>
      import('./domains/ParkingLot/parkinglot.routing').then(
        (m) => m.parkinglotRoutes
      ),
  },

  {
    path: 'dashboard',
    canActivate: baseGuards,
    data: { roles: ['DASHBOARD'] },
    loadChildren: () =>
      import('./domains/Dashboard/dashboard.routing').then(
        (m) => m.dashboardRoutes
      ),
  },
  {
    path: 'camera',
    canActivate: [authenticatedGuard, resetPassGuard, branchGuard, cashGuard],
    loadChildren: () =>
      import('./domains/CameraAlert/camera-alert.routing').then(
        (m) => m.cameraAlertRoutes
      ),
  },

  // Fallback
  { path: '**', redirectTo: 'erro/404', pathMatch: 'full' },
];


